import React from 'react';

import { Paper } from '@mui/material';
import { Link } from 'react-router-dom';

import { formatPercentRatioTwoDecimals } from '../utils/numberUtils';
import './biGauge.css';

const gaugeArcPath = 'M 18 60 A 42 42 0 0 1 102 60';

const getArcPoint = (ratio, radius) => {
    const angle = Math.PI * (1 - ratio);
    return [60 + radius * Math.cos(angle), 60 - radius * Math.sin(angle)];
};

const BiGauge = ({
    detail,
    lowerIsBetter = false,
    max = 1,
    meta,
    title,
    to,
    value
}) => {
    const fill = Math.min(value / max, 1) * 100;
    const metaRatio = meta / max;
    const [tickStartX, tickStartY] = getArcPoint(metaRatio, 27);
    const [tickEndX, tickEndY] = getArcPoint(metaRatio, 57);
    const withinMeta = lowerIsBetter ? value <= meta : value >= meta;

    return (
        <Paper {...(to ? { component: Link, to: `/${to}` } : {})} className={`bi-gauge ${withinMeta ? 'is-ok' : 'is-off'}`}>
            <div className='bi-gauge-heading'>
                <p title={title}>{title}</p>
                <span className='bi-gauge-status'>
                    {withinMeta ? 'Na meta' : 'Fora da meta'}
                </span>
            </div>

            <div className='bi-gauge-chart'>
                <div className='bi-gauge-arc'>
                    <svg viewBox='0 0 120 60' aria-hidden='true'>
                        <path className='bi-gauge-track' d={gaugeArcPath} pathLength='100' />
                        <path className='bi-gauge-value' d={gaugeArcPath} pathLength='100' strokeDasharray={`${fill} 100`} />
                        {metaRatio < 1 && (
                            <line className='bi-gauge-meta' x1={tickStartX} y1={tickStartY} x2={tickEndX} y2={tickEndY} />
                        )}
                    </svg>
                    <strong>{formatPercentRatioTwoDecimals(value)}</strong>
                </div>
                <div className='bi-gauge-scale'>
                    <span>{formatPercentRatioTwoDecimals(0)}</span>
                    <span>{formatPercentRatioTwoDecimals(max)}</span>
                </div>
            </div>

            <div className='bi-gauge-footer'>
                <span>Meta {formatPercentRatioTwoDecimals(meta)}</span>
                <span>{detail}</span>
            </div>
        </Paper>
    );
};

export default BiGauge;
